import {User} from '../_models';

import {Role} from './index';

export class StringsHelper {

  public static getFullName(user: User): string {
    if (!user) return '';
    if (user.firstName != null
      || user.lastName != null) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  public static getRole(role: Role): string {

    let roleStr = '';

    if ((role & (Role.PrimaryManager)) != 0) {
      roleStr = 'Customer Administrator'
    } else if ((role & (Role.PrimaryAdvisorLead)) != 0) {
      roleStr = 'Advisor Admin'
    } else if ((role & (Role.Manager)) != 0) {
      roleStr = 'Manager'
    } else if ((role & (Role.AdvisorLead)) != 0) {
      roleStr = 'Advisor Lead'
    } else if ((role & Role.KingAdmin) != 0) {
      roleStr = 'King Admin'
    } else if ((role & Role.PlatformSupport) != 0) {
      roleStr = 'Platform Support';
    } else {
      roleStr = Role[role];
    }

    return roleStr;
  }
}
